// extracted by mini-css-extract-plugin
export default {"phtvPeopleBox":"index_phtvPeopleBox_iPhfn","phtvPeopleLink":"index_phtvPeopleLink_o-yL-","phtvPeopleLastLink":"index_phtvPeopleLastLink_NR8KC"};